// Mirrors the backend's TextChoices. Kept in one place so the list pages, the
// forms, and the badges cannot drift apart.

export const CLIENT_STATUSES = [
  { value: "prospective", label: "Prospective", tone: "neutral" },
  { value: "active", label: "Active", tone: "positive" },
  { value: "on_hold", label: "On hold", tone: "warning" },
  { value: "discharged", label: "Discharged", tone: "muted" },
];

export const CAREGIVER_STATUSES = [
  { value: "applicant", label: "Applicant", tone: "neutral" },
  { value: "active", label: "Active", tone: "positive" },
  { value: "inactive", label: "Inactive", tone: "muted" },
];

export function statusMeta(statuses, value) {
  return statuses.find((status) => status.value === value) ?? { label: value, tone: "neutral" };
}

/** Roles allowed to change directory records; the API enforces the same list. */
export const DIRECTORY_WRITE_ROLES = ["owner", "admin", "coordinator"];
